import {Box, Dialog, DialogContent, DialogTitle, Grid, Theme, Typography, useMediaQuery} from "@material-ui/core";
import InputBlock from "../image-editor/components/InputBlock";
import {GradientButton} from "../../../../../../../../../property-page-components/PropertyForm";
import {CircularProgress, IconButton, useTheme} from "@mui/material";
import SweetAlert2 from "react-sweetalert2";
import React, {FC, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppStateType} from "../../../../../../../../../../../redux/reducers";
import {useTranslation} from "react-i18next";
import {CloudUpload} from "@mui/icons-material";
import styled from "@emotion/styled";
import {updateProperty} from "../../../../../../../../../../../redux/actions/propertyActions";
import CloseIcon from "@mui/icons-material/Close";

const TopBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    .MuiButtonBase-root {
        width: 42px;
        color: rgba(18, 22, 25, 0.5);
    }
`

const UploadButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);;
  color: black;
  border-radius: 6px;
  border: 1px solid #00F5C3;
  font-weight: 500;
  cursor: pointer;
  padding: 5px 0;
  max-width: 400px;
  width: 100%;
`

const NoHaveImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 400px;
  border-radius: 6px;
  background: #233145;
  color: #9198a2;
`

type PropsType = {
  show: boolean;
  onClose: () => void
}

const GeneralImageEditor: FC<PropsType> = ({show, onClose}) => {
  const theme = useTheme();
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const sm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const isNotDesktop = useMediaQuery(theme.breakpoints.down('md'));

  const property = useSelector((state: AppStateType) => state.propertyReducer.property)!
  const user: any = useSelector((state: AppStateType) => state.authReducer.user);

  const [newImage, setNewImage] = useState<File | null>(null)
  const [newDescription, setNewDescription] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (property) {
      setNewDescription(property.general_image_description)
    }
  }, [property]);

  const handleSave = async () => {
    setLoading(true)

    const formData = new FormData()
    if (newDescription !== property.general_image_description) {
      formData.append('general_image_description', newDescription)
    }
    if (newImage) {
      formData.append('general_image', newImage)
    }
    await dispatch(updateProperty(formData, user.token, property.id));
    onClose()
    setLoading(false)
  }

  const isDisabledSaveButton = () => {
    if (loading || property?.general_image_description === newDescription && !newImage) {
      return true
    }

    return false
  }
  return (
    <Dialog
      fullScreen={isNotDesktop}
      open={show}
      onClose={onClose}
      fullWidth={true}
      maxWidth={'lg'}
      PaperProps={{
        style: {
          borderRadius: isNotDesktop ? 0 : '8px',
        },
      }}
    >
      <TopBar>
        <DialogTitle disableTypography>
          <Typography variant="h4" align="center">General image</Typography>
        </DialogTitle>
        <IconButton
          style={{position: 'absolute', top: '10px', right: '10px'}}
          edge="start"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon style={{color: 'gray'}}/>
        </IconButton>
      </TopBar>
      <DialogContent style={{padding: 24}}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12} md={5}>
            <Box display={"flex"} justifyContent={'center'}>

              {property && property.general_image || newImage ? (
                <img
                  src={newImage ? URL.createObjectURL(newImage) : property?.general_image}
                  style={{
                    maxHeight: '74vh',
                    objectFit: 'contain'
                  }}
                  height={200}
                  width={400}
                />
              ) : (
                <NoHaveImage>
                  {t('no_picture')}
                </NoHaveImage>
              )}
            </Box>
            <Box mt={3}>
              <input
                accept="image/*"
                type="file"
                id={`editor-picture-input`}
                style={{ display: "none" }}
                onChange={(e) => {
                  const {files} = e.target
                  if (files && files.length > 0) {
                    setNewImage(files[0])
                  }
                }}
              />
              <label htmlFor={`editor-picture-input`} style={{display: 'flex', justifyContent: 'center'}}>
                <UploadButton>
                  <Box mr={1}><CloudUpload/></Box>
                  {t('upload_new_picture')}
                </UploadButton>
              </label>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={7}>
            <Box>
              <InputBlock
                title={'image_description'}
                type={'edit'}
                onHandleChange={(e, value) => setNewDescription(value)}
                value={newDescription}
                field={'general_image_description'}
              />
            </Box>
            <Box mt={5} display={'flex'} justifyContent={'center'} alignItems={'center'}>
              <GradientButton
                disabled={isDisabledSaveButton()}
                onClick={() => handleSave()}
                style={{minWidth: '100px'}}
              >
                {t('propertyForm_save')}
                {loading ? (
                  <Box ml={1} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <CircularProgress size={15}/>
                  </Box>
                ) : null}
              </GradientButton>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default GeneralImageEditor